import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setDialogBox } from '../Slice/billingScreenSlice'
import AuthenticationDialog from './AuthenticationDialog'
import { authenticateEmployeeAPI } from '../API/employeeAuthAPI'
import { errorSnackMsg } from '../../../../Custom Hooks/SnackkBarUtilities'
import HttpsIcon from '@mui/icons-material/Https';
import { setAuthPassword } from '../newBillingSlice'

const UpdateOrderAuth = ({ submitClick, text, authType }) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const { authPassWord } = useSelector((state) => state.newBillingSlice)
    const branchConfigurationList = useSelector((state) => state.newBillingSlice.branchConfigurationList)
    const branchSettingsView = useSelector((state) => state.branchSettingsSliceNew.rowData)
    
    // Get authorized employees based on auth type
    const getAuthorizedEmployees = () => {
        const branchConfig = branchSettingsView || branchConfigurationList
        
        if (authType === 'orderEdit') {
            return (branchConfig?.updateOrdAuthEmployees || []).map((emp) => ({
                _id: emp?.employeeId || emp?._id,
                staff_name: emp?.name || emp?.staff_name,
            }))
        } else if (authType === 'orderCancel') {
            return (branchConfig?.cancelOrdAuthEmployees || []).map((emp) => ({
                _id: emp?.employeeId || emp?._id,
                staff_name: emp?.name || emp?.staff_name,
            }))
        } else if (authType === 'discount') {
            return (branchConfig?.addDiscountAuthEmployees || []).map((emp) => ({
                _id: emp?.employeeId || emp?._id,
                staff_name: emp?.name || emp?.staff_name,
            }))
        }
        return []
    }

    const authorizedEmployees = getAuthorizedEmployees()
    const isSingleEmployee = authorizedEmployees.length === 1

    // Handle authentication for single employee using existing password from Redux
    const handleSimpleAuth = async () => {
        if (!authPassWord) {
            errorSnackMsg('Please enter password')
            return
        }

        const result = await authenticateEmployeeAPI(
            {
                employeeId: authorizedEmployees[0]._id,
                password: authPassWord
            },
            setLoading
        )

        if (result.success) {
            dispatch(setAuthPassword(''))
            dispatch(setDialogBox(null))
            submitClick()
        }
    }

    // Handle authentication for multiple employees (employee selection + password)
    const handleMultipleAuth = async (selectedEmployee, password) => {
        if (!selectedEmployee || !password) {
            errorSnackMsg('Please select an employee and enter password')
            return
        }

        const result = await authenticateEmployeeAPI(
            {
                employeeId: selectedEmployee._id,
                password: password
            },
            setLoading
        )

        if (result.success) {
            // Check if employee is in authorized list
            const isAuthorized = authorizedEmployees.some(emp => emp._id === selectedEmployee._id)
            
            if (!isAuthorized) {
                errorSnackMsg('This employee is not authorized for this operation')
                return
            }

            // Close dialog and proceed with operation
            dispatch(setDialogBox(null))
            submitClick()
        }
    }

    const handleClose = () => {
        dispatch(setDialogBox(null))
    }

    // Show existing old password UI for single employee
    if (isSingleEmployee) {
        return (
            <div className='wallet-change-dialog' style={{ maxWidth: "350px", minWidth: "350px" }}>
                <div className="head justify-center">
                    <div className="icon justify-center" style={{ backgroundColor: "#dfaab4" }}>
                        <HttpsIcon color='error' />
                    </div>
                    {text}
                </div>
                <div className="input-ctn">
                    <button disabled className="btn" style={{ minWidth: "45px" }}>
                        <HttpsIcon fontSize='small' color="error" />
                    </button>
                    <input
                        value={authPassWord}
                        placeholder='Password'
                        type="password"
                        id="password"
                        name="password"
                        autoComplete="new-password"
                        style={{ textAlign: "start" }}
                        onChange={(e) => dispatch(setAuthPassword(e.target.value))}
                        onKeyDown={(e) => e.key === "Enter" && handleSimpleAuth()}
                    />
                </div>
                <div className="wallet-change-btn" style={{ justifyContent: "center" }}>
                    <button
                        onClick={() => dispatch(setDialogBox(null))}
                        className="btn-secondary-outlined btn">
                        Cancel
                    </button>
                    <button
                        onClick={handleSimpleAuth}
                        className="btn-primary btn" 
                        style={{ backgroundColor: "#c01c1b" }}>
                        Submit
                    </button>
                </div>
            </div>
        )
    }

    // Show employee selection UI for multiple employees
    return (
        <AuthenticationDialog
            open={true}
            onClose={handleClose}
            onAuthenticate={handleMultipleAuth}
            employees={authorizedEmployees}
            title={text}
            message={`Please select an authorized employee and enter their password to ${text.toLowerCase()}.`}
        />
    )
}

export default UpdateOrderAuth